<div class="loading-overlay" *ngIf="isLoading && !isModalOpen">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>
<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <div class="ports-table-container">
      <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative mb-0">
      <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
        <div class="relative w-full max-w-xs">
          <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
          <input
            type="text"
            class="search-input-ports w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
            [(ngModel)]="searchTerm"
            (input)="applyFilter()"
            placeholder="Rechercher une machine par nom..."
          />
        </div>
        <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
          {{ getFilteredDevicesCount() }} machine{{ getFilteredDevicesCount() > 1 ? 's' : '' }}
        </span>
      </div>
      
      <button 
        *ngIf="archiveFilter !== 'archived'"
        class="add-user-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
        (click)="openAddDeviceModal()"
        title="Ajouter une machine">
        <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
        <span class="add-user-button-text text-sm font-medium whitespace-nowrap">Ajouter une machine</span>
      </button>
    </div>

    <div class="archive-toggle-bar px-6 py-3 mb-0">
      <button
        type="button"
        class="archive-toggle-card"
        [ngClass]="{ 'active': archiveFilter === 'active' }"
        (click)="setArchiveFilter('active')">
        <span class="material-symbols-outlined">memory</span>
        <div class="archive-toggle-content">
          <div class="archive-toggle-title">Machines actives</div>
          <div class="archive-toggle-count">{{ getArchiveCount('active') }}</div>
        </div>
      </button>

      <button
        type="button"
        class="archive-toggle-card"
        [ngClass]="{ 'active': archiveFilter === 'archived' }"
        (click)="setArchiveFilter('archived')">
        <span class="material-symbols-outlined">archive</span>
        <div class="archive-toggle-content">
          <div class="archive-toggle-title">Archives</div>
          <div class="archive-toggle-count">{{ getArchiveCount('archived') }}</div>
        </div>
      </button>

      <button
        type="button"
        class="archive-toggle-card"
        [ngClass]="{ 'active': archiveFilter === 'all' }"
        (click)="setArchiveFilter('all')">
        <span class="material-symbols-outlined">all_inclusive</span>
        <div class="archive-toggle-content">
          <div class="archive-toggle-title">Tout afficher</div>
          <div class="archive-toggle-count">{{ getArchiveCount('all') }}</div>
        </div>
      </button>
    </div>

    <div class="table-responsive-modern mb-5">
      <table class="table-modern">
        <thead>
          <tr>
            <th class="col-select">
              <span class="header-text">Sélection</span>
            </th>
            <th class="col-priority">
              <span class="header-text">Priorité</span>
            </th>
            <th class="col-name">
              <span class="header-text">Nom de la machine</span>
            </th>
            <th class="col-config">
              <span class="header-text">Horaires</span>
              <span class="header-subtitle">Envoi → Pause</span>
            </th>
            <th class="col-status">
              <span class="header-text">Contrôles</span>
              <span class="header-subtitle">Envoi / Init</span>
            </th>
            <th class="col-stats">
              <span class="header-text">Statistiques</span>
              <span class="header-subtitle">SMS attribués / En attente</span>
            </th>
            <th class="col-actions">
              <span class="header-text">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of filteredDevices; index as i" 
              class="device-row-modern"
              [ngClass]="{'row-selected': selectedDevice?._id === d._id}">
            
            <td class="col-select">
              <input type="checkbox" 
                     [checked]="selectedDevice?._id === d._id" 
                     (change)="toggleDeviceSelection(d, $event)"
                     class="checkbox-modern" />
            </td>
            
            <td class="col-priority">
              <input type="number" 
                     class="input-priority-modern" 
                     [(ngModel)]="d.priorite" 
                     min="1" 
                     (keydown.enter)="updateDevicePriority(d, d.priorite); $event.preventDefault()" />
            </td>
            
            <td class="col-name">
              <div class="device-name-modern">
                <div class="name-row">
                  <div class="name-row-left">
                    <span class="connection-status-icon-inline" 
                          [ngClass]="{'online': d.isOnline, 'offline': !d.isOnline}"
                          [title]="d.isOnline ? 'En ligne' : 'Hors ligne'">
                      <span class="material-symbols-outlined">{{ d.isOnline ? 'wifi' : 'wifi_off' }}</span>
                    </span>
                    <span class="lock-icon-mini" 
                          *ngIf="d.locks" 
                          title="Verrouillé - cliquer pour déverrouiller"
                          (click)="unlockLocks(d, $event)">
                      <span class="material-symbols-outlined">lock</span>
                    </span>
                    <span class="device-name-text" 
                          (click)="openDeviceUrl(d)"
                          [ngClass]="{'has-url': d.ip, 'no-url': !d.ip}">
                      {{ d.name }}
                    </span>
                    <i class="fas fa-external-link-alt ms-1 link-icon" *ngIf="d.ip"></i>
                    <button class="btn-icon-mini" 
                            (click)="startEditingDeviceName(d, $event)"
                            title="Modifier">
                      <span class="material-symbols-outlined">edit</span>
                    </button>
                  </div>
                  <span class="device-config-badge" title="Configuration : {{ d.nbPorts }} ports × {{ d.nbSlots }} slots">
                    <span class="config-numbers">{{ d.nbPorts }} × {{ d.nbSlots }}</span>
                    <span class="material-symbols-outlined config-icon">memory</span>
                  </span>
                </div>
                <div *ngIf="editingDeviceId === d._id" class="edit-row">
                  <input type="text" 
                         class="form-control form-control-sm" 
                         [(ngModel)]="editingDeviceName"
                         (keydown.enter)="saveDeviceName(d); $event.preventDefault()"
                         (keydown.escape)="cancelEditingDeviceName()" />
                  <button class="btn-icon-mini btn-success" (click)="saveDeviceName(d)">
                    <span class="material-symbols-outlined">check</span>
                  </button>
                  <button class="btn-icon-mini btn-danger" (click)="cancelEditingDeviceName()">
                    <span class="material-symbols-outlined">close</span>
                  </button>
                </div>
                <div class="device-id-modern" 
                     [title]="'ID: ' + d._id + ' (cliquez pour copier)'"
                     (click)="copyToClipboard(d._id, $event); $event.stopPropagation()">
                  {{ d._id }}
                </div>
                <div class="device-comment-modern"
                     *ngIf="commentEditDeviceId !== d._id && d.commentaire && d.commentaire.trim()">
                  <span class="material-symbols-outlined">comment</span>
                  <span class="device-comment-text" [title]="d.commentaire">{{ d.commentaire }}</span>
                  <button 
                    type="button" 
                    class="btn-icon-mini btn-comment-edit"
                    (click)="startEditComment(d, $event)">
                    <span class="material-symbols-outlined">edit</span>
                  </button>
                </div>
                <div class="device-comment-edit-row" *ngIf="commentEditDeviceId === d._id">
                  <input
                    type="text"
                    class="device-comment-input"
                    [(ngModel)]="commentEditValue"
                    placeholder="Ajouter un commentaire…"
                  />
                  <button 
                    type="button" 
                    class="btn-icon-mini btn-success"
                    (click)="saveCommentForDevice(d)">
                    <span class="material-symbols-outlined">check</span>
                  </button>
                  <button 
                    type="button" 
                    class="btn-icon-mini btn-danger"
                    (click)="cancelEditComment($event)">
                    <span class="material-symbols-outlined">close</span>
                  </button>
                </div>
                <button
                  *ngIf="(!d.commentaire || !d.commentaire.trim()) && commentEditDeviceId !== d._id"
                  type="button"
                  class="device-comment-add-btn"
                  (click)="startEditComment(d, $event)">
                  <span class="material-symbols-outlined">add_comment</span>
                  <span>Ajouter un commentaire</span>
                </button>
              </div>
            </td>
            
            <td class="col-config">
              <div class="config-modern">
                <div class="config-hours-container">
                  <div class="config-hours-section config-hours-envoi">
                    <div class="hours-type-badge hours-type-envoi" title="Horaire d'envoi">E</div>
                    <div class="config-hours" 
                         [ngClass]="{'hours-in': isWithinHoursInterval(d.heureDebut, d.heureFin), 'hours-out': !isWithinHoursInterval(d.heureDebut, d.heureFin) || !d.heureDebut || !d.heureFin}">
                      <input type="time" 
                             class="hours-input-time" 
                             [value]="normalizeTimeForInput(d.heureDebut)"
                             (change)="onHoursFieldChange(d, 'heureDebut', $event)"
                             (keydown.enter)="saveAllDeviceHours(d, $event)"
                             [title]="'Heure de début d\'envoi'">
                      <span class="hours-arrow">→</span>
                      <input type="time" 
                             class="hours-input-time" 
                             [value]="normalizeTimeForInput(d.heureFin)"
                             (change)="onHoursFieldChange(d, 'heureFin', $event)"
                             (keydown.enter)="saveAllDeviceHours(d, $event)"
                             [title]="'Heure de fin d\'envoi'">
                    </div>
                  </div>
                  <div class="config-hours-section config-hours-pause">
                    <div class="hours-type-badge hours-type-pause" title="Horaire de pause">P</div>
                    <div class="config-hours" 
                         [ngClass]="{'hours-in': isWithinHoursInterval(d.heureDebutPause, d.heureFinPause), 'hours-out': !isWithinHoursInterval(d.heureDebutPause, d.heureFinPause) || !d.heureDebutPause || !d.heureFinPause}">
                      <input type="time" 
                             class="hours-input-time" 
                             [value]="normalizeTimeForInput(d.heureDebutPause)"
                             (change)="onHoursFieldChange(d, 'heureDebutPause', $event)"
                             (keydown.enter)="saveAllDeviceHours(d, $event)"
                             [title]="'Heure de début de pause'">
                      <span class="hours-arrow">→</span>
                      <input type="time" 
                             class="hours-input-time" 
                             [value]="normalizeTimeForInput(d.heureFinPause)"
                             (change)="onHoursFieldChange(d, 'heureFinPause', $event)"
                             (keydown.enter)="saveAllDeviceHours(d, $event)"
                             [title]="'Heure de fin de pause'">
                    </div>
                  </div>
                </div>
              </div>
            </td>
            
            <td class="col-status">
              <div class="status-modern">
                <button type="button"
                        class="btn-toggle-modern"
                        [ngClass]="d.isUsed ? 'btn-off' : 'btn-on'"
                        (click)="toggleDeviceStatus(d)"
                        [disabled]="isLoading">
                  {{ d.isUsed ? 'Désactiver l\'envoi' : 'Activer l\'envoi' }}
                </button>
                <button type="button"
                        class="btn-toggle-modern btn-init-toggle"
                        [ngClass]="d.phoneNumbersInitialized ? 'btn-off' : 'btn-on'"
                        (click)="toggleDeviceInit(d)"
                        [disabled]="isLoading">
                  {{ d.phoneNumbersInitialized ? 'Désactiver init' : 'Activer init' }}
                </button>
              </div>
            </td>
            
            <td class="col-stats">
              <div class="stats-row-modern">
                <div class="stat-badge-modern" [ngClass]="{ 'has-value': (d.pendingSmsCount || 0) > 0 }" title="SMS attribués">
                  <span class="material-symbols-outlined stat-icon">hourglass</span>
                  <span class="stat-number">{{ d.pendingSmsCount !== undefined ? d.pendingSmsCount : '...' }}</span>
                </div>
                <div class="stat-badge-modern"
                     [ngClass]="{ 'has-value': (d.pendingSmsCountWaitingConfirmation || 0) > 0 }"
                     title="Cliquer pour relancer les délivrés pour cette machine"
                     (click)="relancerDeliveredForDevice(d)"
                     [style.cursor]="(d.pendingSmsCountWaitingConfirmation || 0) > 0 ? 'pointer' : 'default'">
                  <span class="material-symbols-outlined stat-icon">pending</span>
                  <span class="stat-number">{{ d.pendingSmsCountWaitingConfirmation !== undefined ? d.pendingSmsCountWaitingConfirmation : '...' }}</span>
                </div>
              </div>
            </td>
            
            <td class="col-actions">
              <div class="actions-row-modern">
                <button type="button" class="btn-action-modern btn-view" (click)="openPopup(d, $event)" title="Voir">
                  <span class="material-symbols-outlined">visibility</span>
                </button>
                <button class="btn-action-modern btn-export" (click)="exportDevicePhoneNumbers(d)" title="Exporter">
                  <span class="material-symbols-outlined">table_view</span>
                </button>
                <button class="btn-action-modern btn-reset" (click)="resetDevice(d)" title="Reset">
                  <span class="material-symbols-outlined">skull</span>
                </button>
                <button class="btn-action-modern btn-phone" 
                        (click)="selectDeviceAndCheckRecovery(d)" 
                        [disabled]="isPhoneRecoveryLoading"
                        title="Téléphone">
                  <span class="material-symbols-outlined">phone</span>
                </button>
                <button class="btn-action-modern btn-archive"
                        [ngClass]="d.isArchive ? 'archived' : 'active'"
                        (click)="toggleArchiveStatus(d)"
                        [disabled]="isLoading"
                        [title]="d.isArchive ? 'Désarchiver' : 'Archiver'">
                  <span class="material-symbols-outlined">{{ d.isArchive ? 'unarchive' : 'archive' }}</span>
                </button>
                <button class="btn-action-modern btn-delete" (click)="deleteDevice(d)" title="Supprimer">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div *ngIf="filteredDevices.length === 0" class="empty-state">
      <span class="material-symbols-outlined">memory</span>
      <p>Aucune machine trouvée</p>
    </div>

    <div *ngIf="selectedDevice" class="mt-8 max-w-5xl mx-auto px-4">
      <div class="mb-5">
        <h5 class="text-base font-semibold text-gray-800 flex items-center gap-2">
          <span class="text-lg">⚙️</span>
          <span>Configuration générale des ports</span>
        </h5>
      </div>
      
      <div class="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50 border-b border-gray-200">
              <tr>
                <th class="px-4 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">#</th>
                <th class="px-3 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">Auto</th>
                <th class="px-3 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">Fonctionnel</th>
                <th class="px-3 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">À modifier</th>
                <th class="px-4 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">État</th>
                <th class="px-4 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">Type</th>
                <th class="px-4 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">SMS restants</th>
                <th class="px-4 py-3 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">MMS restants</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr class="bg-gray-50/60 hover:bg-gray-50 transition-colors">
                <td class="px-4 py-3 text-center text-lg font-semibold text-gray-900">Général</td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    (click)="toggleGeneral('testAutomatique')" 
                    [checked]="testAutomatique == 'y'"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    (click)="toggleGeneral('use')" 
                    [checked]="use == 'y'"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    (click)="toggleGeneral('updateCheckbox')" 
                    [checked]="updateCheckbox == 'y'"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ general === 'o' ? '🟢' : '🔴' }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ type === 's' ? 'SMS' : 'MMS' }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ limiteSms }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ limiteMms }}</span>
                </td>
              </tr>

              <tr *ngFor="let p of ports; index as i" class="hover:bg-gray-50/50 transition-colors">
                <td class="px-4 py-3 text-center text-lg font-medium text-gray-900">{{p.slotActuel.port}}</td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    [checked]="p.testAutomatique === 'y'" 
                    (change)="toggleField(p._id, 'testAutomatique')"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    [checked]="p.use === 'y'" 
                    (change)="toggleField(p._id, 'use')"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-3 py-3 text-center">
                  <input 
                    type="checkbox" 
                    [checked]="p.updateCheckbox === 'y'" 
                    (change)="toggleField(p._id, 'updateCheckbox')"
                    class="w-6 h-6 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ p.isOpen === 'o' ? '🟢' : '🔴' }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ p.type === 's' ? 'SMS' : 'MMS' }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ p.limiteSms }}</span>
                </td>
                <td class="px-4 py-3 text-center">
                  <span class="text-lg font-bold text-gray-900">{{ p.limiteMms }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-6 mb-6 px-6 flex justify-center">
        <button 
          class="save-ports-button group relative inline-flex items-center justify-center gap-2.5 px-8 py-3.5 text-sm font-semibold text-white rounded-xl shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-300 ease-out disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-lg"
          [class.saving]="isLoading"
          (click)="update()"
          [disabled]="isLoading">
          <span class="material-symbols-outlined save-icon text-lg">
            {{ isLoading ? 'hourglass_empty' : 'save' }}
          </span>
          <span class="save-text">{{ isLoading ? 'Sauvegarde...' : 'Sauvegarder les ports' }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="modal fade" id="deviceDetailModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">🔍 Détails de la machine : {{ selectedDevice?.name }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="device-info-header-modern mb-4">
            <div class="machine-name-card">
              <div class="machine-name-content">
                <div class="machine-icon-wrapper">
                  <span class="material-symbols-outlined machine-icon">computer</span>
                </div>
                <div class="machine-name-text-wrapper">
                  <div class="machine-name-label">NOM DE LA MACHINE</div>
                  <div class="machine-name-value device-name-clickable" 
                       (click)="openDeviceUrl(selectedDevice)" 
                       [title]="selectedDevice?.ip ? 'Cliquez pour ouvrir l\'interface : ' + selectedDevice.ip : 'Aucune URL configurée'"
                       [ngClass]="{'has-url': selectedDevice?.ip, 'no-url': !selectedDevice?.ip}">
                    {{ selectedDevice?.name }}
                    <i class="fas fa-external-link-alt ms-1" *ngIf="selectedDevice?.ip"></i>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="info-cards-modern">
              <div class="info-card-modern">
                <div class="info-icon-modern">
                  <span class="material-symbols-outlined">power</span>
                </div>
                <div class="info-content-modern">
                  <div class="info-label-modern">PORTS</div>
                  <div class="info-value-modern">{{ selectedDevice?.nbPorts }}</div>
                </div>
              </div>
              
              <div class="info-card-modern">
                <div class="info-icon-modern">
                  <span class="material-symbols-outlined">inventory_2</span>
                </div>
                <div class="info-content-modern">
                  <div class="info-label-modern">SLOTS</div>
                  <div class="info-value-modern">{{ selectedDevice?.nbSlots }}</div>
                </div>
              </div>
              
              <div class="info-card-modern">
                <div class="info-icon-modern" [ngClass]="{'icon-active': selectedDevice?.isUsed, 'icon-inactive': !selectedDevice?.isUsed}">
                  <span class="material-symbols-outlined">{{ selectedDevice?.isUsed ? 'check_circle' : 'cancel' }}</span>
                </div>
                <div class="info-content-modern">
                  <div class="info-label-modern">UTILISÉE</div>
                  <div class="info-value-modern">{{ selectedDevice?.isUsed ? 'Oui' : 'Non' }}</div>
                </div>
              </div>
              
              <div class="info-card-modern">
                <div class="info-icon-modern" [ngClass]="{'icon-online': selectedDevice?.isOnline, 'icon-offline': !selectedDevice?.isOnline}">
                  <span class="material-symbols-outlined">{{ selectedDevice?.isOnline ? 'circle' : 'circle' }}</span>
                </div>
                <div class="info-content-modern">
                  <div class="info-label-modern">STATUT</div>
                  <div class="info-value-modern">{{ selectedDevice?.isOnline ? 'En ligne' : 'Hors ligne' }}</div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="shouldShowEnvoiStats()" class="stats-grid mb-4">
            <div class="stat-card stat-card-primary">
              <div class="stat-icon">📊</div>
              <div class="stat-content">
                <div class="stat-label">Envoi moyen</div>
                <div class="stat-value">{{ envoiMoyen }}</div>
              </div>
            </div>
            
            <div class="stat-card">
              <div class="stat-icon">📈</div>
              <div class="stat-content">
                <div class="stat-label">Envoi total</div>
                <div class="stat-value">{{ envoiTotal }}</div>
              </div>
            </div>
            
            <div class="stat-card">
              <div class="stat-icon">📅</div>
              <div class="stat-content">
                <div class="stat-label">Total jour</div>
                <div class="stat-value">{{ envoiTotalJour }}</div>
              </div>
            </div>
            
            <div class="stat-card">
              <div class="stat-icon">⏰</div>
              <div class="stat-content">
                <div class="stat-label">Total heure</div>
                <div class="stat-value">{{ envoiTotalHeure }}</div>
              </div>
            </div>
            
            <div class="stat-card">
              <div class="stat-icon">📊</div>
              <div class="stat-content">
                <div class="stat-label">Moyen jour</div>
                <div class="stat-value">{{ envoiMoyenJour }}</div>
              </div>
            </div>
            
            <div class="stat-card stat-card-cost" *ngIf="!shouldShowRevenuStats()">
              <div class="stat-icon">💵</div>
              <div class="stat-content">
                <div class="stat-label">Coût par SMS</div>
                <div class="stat-value">{{ coutParSms | number:'1.6-6' }} $</div>
              </div>
            </div>
            
            <div class="stat-card stat-card-cost" *ngIf="!shouldShowRevenuStats()">
              <div class="stat-icon">💵</div>
              <div class="stat-content">
                <div class="stat-label">Coût par SMS (sans réception)</div>
                <div class="stat-value">{{ coutParSmsSansReception | number:'1.6-6' }} $</div>
              </div>
            </div>
          </div>

          <div *ngIf="shouldShowRevenuStats()" class="stats-grid mb-4">
            <div class="stat-card stat-card-revenue">
              <div class="stat-icon">💰</div>
              <div class="stat-content">
                <div class="stat-label">Revenu réception</div>
                <div class="stat-value">{{ revenuTotalGeneratedReception | number:'1.2-2' }} $</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">📈</div>
              <div class="stat-content">
                <div class="stat-label">Revenu moyen / puce</div>
                <div class="stat-value">{{ revenuMoyenGeneratedReception | number:'1.2-2' }} $</div>
              </div>
            </div>
          </div>

          <div *ngIf="shouldShowPhoneStats()" class="phone-stats-grid mb-4">
            <div class="stat-card stat-card-phone">
              <div class="stat-icon">📱</div>
              <div class="stat-content">
                <div class="stat-label">Tél. récupérés</div>
                <div class="stat-value">{{ nbDeTelRecupere }}</div>
              </div>
            </div>
            
            <div class="stat-card stat-card-phone">
              <div class="stat-icon">📵</div>
              <div class="stat-content">
                <div class="stat-label">Tél. non récupérés</div>
                <div class="stat-value">{{ nbDeTelNonRecupere }}</div>
              </div>
            </div>
            
            <div class="stat-card stat-card-ratio">
              <div class="stat-icon">📊</div>
              <div class="stat-content">
                <div class="stat-label">Ratio récupération</div>
                <div class="stat-value">{{ ratioTelRecupere }}%</div>
              </div>
            </div>
          </div>
          
          <div class="row mb-4">
            <div class="col-12">
              <h6 class="fw-bold mb-3">Légendes des états :</h6>
              <div class="d-flex flex-wrap gap-3">
                <div class="d-flex align-items-center">
                  <div class="status-indicator bg-success me-2"></div>
                  <span class="fw-semibold">Ouvert</span>
                </div>
                <div class="d-flex align-items-center">
                  <div class="status-indicator bg-danger me-2"></div>
                  <span class="fw-semibold">Fermé</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="display-modes-container mb-3">
            <div class="display-mode-card display-mode-left">
              <label class="display-mode-label">Mode d'affichage gauche</label>
              <select class="display-mode-select" [(ngModel)]="selectedDisplayModeLeft">
                <option value="portStatus">Statut des ports</option>
                <option value="totalEnvoi">Envoi total</option>
                <option value="totalEnvoiHeure">Envoi total / heure</option>
                <option value="totalEnvoiJour">Envoi total / jour</option>
                <option value="revenuGeneratedReception">Revenu réception</option>
                <option value="phoneNumber">Numéro de téléphone</option>
              </select>
            </div>
            <div class="display-mode-card display-mode-right">
              <label class="display-mode-label">Mode d'affichage droite</label>
              <select class="display-mode-select" [(ngModel)]="selectedDisplayMode">
                <option value="totalEnvoi">Envoi total</option>
                <option value="totalEnvoiHeure">Envoi total / heure</option>
                <option value="totalEnvoiJour">Envoi total / jour</option>
                <option value="revenuGeneratedReception">Revenu réception</option>
                <option value="phoneNumber">Numéro de téléphone</option>
                <option value="portStatus">Statut des ports</option>
              </select>
            </div>
          </div>
          
          <hr />
          
          <div *ngIf="isModalLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Chargement...</span>
            </div>
            <p class="mt-2">Chargement des ports...</p>
          </div>
          
          <div *ngIf="!isModalLoading && ports.length > 0" class="row g-4">
            <div class="col-md-6 port-column-left">
              <div *ngFor="let portBlock of getPortBlocks(); let blockIndex = index" class="port-block-container">
                <h6 class="fw-bold mb-3">Ports {{ portBlock.start }} - {{ portBlock.end }}</h6>
                
                <div class="d-flex mb-2 align-items-center">
                  <div class="port-label me-2 fw-bold">Slot\Port</div>
                  <div *ngFor="let port of portBlock.ports" class="port-header">{{ port }}</div>
                </div>
                
                <!-- Lignes des slots -->
                <div *ngFor="let slot of getSlotNumbers()" class="d-flex mb-1 align-items-center">
                  <div class="slot-label me-2 fw-bold">.{{ slot }}</div>
                  <div *ngFor="let port of portBlock.ports" 
                       [class]="getSlotDisplayClassByMode(port, slot, selectedDisplayModeLeft)"
                       [ngClass]="{'slot-actuel': isSlotActuel(port, slot) && selectedDisplayModeLeft !== 'revenuGeneratedReception'}"
                       class="port-slot-cell"
                       [attr.data-port]="port"
                       [attr.data-slot]="slot"
                       [attr.data-mode]="selectedDisplayModeLeft"
                       (pointerup)="onSlotPointerUp(port, slot, selectedDisplayModeLeft, $event)"
                       [style.cursor]="shouldShowIndicator(selectedDisplayModeLeft) ? 'pointer' : 'default'"
                       [title]="getSlotTitle(port, slot, selectedDisplayModeLeft)">
                    <div *ngIf="shouldShowIndicator(selectedDisplayModeLeft) && (selectedDisplayModeLeft !== 'phoneNumber' || getSlotValueByMode(port, slot, selectedDisplayModeLeft))" 
                         class="port-slot-indicator"></div>
                    <span *ngIf="!shouldShowIndicator(selectedDisplayModeLeft)" class="slot-value">{{ getSlotValueByMode(port, slot, selectedDisplayModeLeft) }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-md-6 port-column-right">
              <div *ngFor="let portBlock of getPortBlocks(); let blockIndex = index" class="port-block-container">
                <h6 class="fw-bold mb-3">Ports {{ portBlock.start }} - {{ portBlock.end }}</h6>
                
                <div class="d-flex mb-2 align-items-center">
                  <div class="port-label me-2 fw-bold">Slot\Port</div>
                  <div *ngFor="let port of portBlock.ports" class="port-header">{{ port }}</div>
                </div>
                
                <!-- Lignes des slots -->
                <div *ngFor="let slot of getSlotNumbers()" class="d-flex mb-1 align-items-center">
                  <div class="slot-label me-2 fw-bold">.{{ slot }}</div>
                  <div *ngFor="let port of portBlock.ports" 
                       [class]="getSlotDisplayClassByMode(port, slot, selectedDisplayMode)"
                       [ngClass]="{'slot-actuel': isSlotActuel(port, slot) && selectedDisplayMode !== 'revenuGeneratedReception'}"
                       class="port-slot-cell"
                       [attr.data-port]="port"
                       [attr.data-slot]="slot"
                       [attr.data-mode]="selectedDisplayMode"
                       (pointerup)="onSlotPointerUp(port, slot, selectedDisplayMode, $event)"
                       [style.cursor]="shouldShowIndicator(selectedDisplayMode) ? 'pointer' : 'default'"
                       [title]="getSlotTitle(port, slot, selectedDisplayMode)">
                    <div *ngIf="shouldShowIndicator(selectedDisplayMode) && (selectedDisplayMode !== 'phoneNumber' || getSlotValueByMode(port, slot, selectedDisplayMode))" 
                         class="port-slot-indicator"></div>
                    <span *ngIf="!shouldShowIndicator(selectedDisplayMode)" class="slot-value">{{ getSlotValueByMode(port, slot, selectedDisplayMode) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div *ngIf="!isModalLoading && ports.length === 0" class="text-center py-4">
            <p class="text-muted">Aucun port trouvé pour cette machine.</p>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="phoneNumberInputModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">📱 Saisie du numéro témoin</h5>
        </div>
        <div class="modal-body">
          <div class="alert alert-info">
            <strong>ℹ️ Information :</strong><br>
            Ce numéro sera utilisé comme témoin pour récupérer les numéros de téléphone des autres slots.
            Il sera assigné au slot <strong>1.01</strong> de la machine <strong>{{ selectedDevice?.name }}</strong>.
          </div>
          
          <div class="mb-3">
            <label class="form-label fw-bold">Numéro de téléphone témoin :</label>
            <input type="tel" 
                   class="form-control" 
                   [(ngModel)]="manualPhoneNumber" 
                   placeholder="+33123456789 ou 0123456789"
                   [class.is-invalid]="manualPhoneNumber && !isValidPhoneNumber(manualPhoneNumber)"
                   maxlength="15">
            <div class="form-text">
              Formats acceptés : +33XXXXXXXXX, 0XXXXXXXXX, ou 33XXXXXXXXX
            </div>
            <div class="invalid-feedback" *ngIf="manualPhoneNumber && !isValidPhoneNumber(manualPhoneNumber)">
              Format de numéro invalide
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" 
                  class="btn btn-secondary" 
                  (click)="cancelManualPhoneNumber()"
                  [disabled]="isPhoneRecoveryLoading">
            Annuler
          </button>
          <button type="button" 
                  class="btn btn-primary" 
                  (click)="confirmManualPhoneNumber()"
                  [disabled]="isPhoneRecoveryLoading || !manualPhoneNumber || !isValidPhoneNumber(manualPhoneNumber)">
            <span *ngIf="isPhoneRecoveryLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isPhoneRecoveryLoading ? 'Traitement...' : 'Confirmer' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="isPhoneRecoveryLoading && !showPhoneNumberInput && !isModalOpen">
    <div class="loader-container">
      <div class="loader-spinner"></div>
      <p class="loader-text">Chargement en cours...</p>
      <p class="loader-subtext">Cela peut prendre quelques minutes</p>
    </div>
  </div>

  <div class="users-modal-overlay" *ngIf="showAddDeviceModal">
    <div class="users-modal-content" #addDeviceModalContent>
      <div class="users-modal-header">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-white text-lg">memory</span>
          </div>
          <h2 class="text-lg font-semibold text-gray-900">Ajouter une machine</h2>
        </div>
        <div class="flex items-center gap-4">
          <div class="flex items-center gap-2">
            <input 
              type="checkbox" 
              id="usedForReception"
              class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
              [(ngModel)]="device.usedForReception" 
              name="usedForReception" />
            <label for="usedForReception" class="text-sm font-medium text-gray-700 cursor-pointer">
              Utilisable pour réception
            </label>
          </div>
          <button 
            class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
            (click)="closeAddDeviceModal()" 
            type="button"
            [disabled]="isLoading">
            <span class="material-symbols-outlined text-lg">close</span>
          </button>
        </div>
      </div>
      
      <div class="users-modal-body">
        <form (ngSubmit)="addDevice(); $event.preventDefault()" id="addDeviceForm">
          <div class="mb-6">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
              <div class="flex flex-col gap-1.5 md:col-span-4">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nom de la machine
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  class="users-form-input" 
                  [(ngModel)]="device.name" 
                  name="name" 
                  placeholder="Ex : Machine 1" 
                  required 
                  autofocus />
              </div>
              
              <div class="flex flex-col gap-1.5 md:col-span-3">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nombre de ports
                  <span class="text-red-500">*</span>
                </label>
                <select class="users-form-select" [(ngModel)]="device.nbPorts" name="nbPorts" required>
                  <option [ngValue]="null" disabled selected>Sélectionner</option>
                  <option *ngFor="let nb of [8, 16, 32, 64]" [value]="nb">{{ nb }} ports</option>
                </select>
              </div>
              
              <div class="flex flex-col gap-1.5 md:col-span-3">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nombre de slots
                  <span class="text-red-500">*</span>
                </label>
                <select class="users-form-select" [(ngModel)]="device.nbSlots" name="nbSlots" required>
                  <option [ngValue]="null" disabled selected>Sélectionner</option>
                  <option *ngFor="let nb of [1, 2, 4, 8, 16, 32]" [value]="nb">{{ nb }} slots</option>
                </select>
              </div>
              
              <div class="flex flex-col gap-1.5 md:col-span-2">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Priorité
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="users-form-input" 
                  [(ngModel)]="device.priorite" 
                  name="priorite" 
                  placeholder="1" 
                  min="1" 
                  required />
              </div>
            </div>
          </div>
          
          <div class="border-t border-gray-200 pt-4">
            <div class="space-y-3">
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex items-start gap-2.5">
                  <input 
                    class="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
                    type="checkbox" 
                    id="configureMachine" 
                    [(ngModel)]="device.configureMachine" 
                    name="configureMachine">
                  <label class="flex flex-col cursor-pointer flex-1" for="configureMachine">
                    <span class="text-sm font-medium text-gray-900">Paramétrer la machine</span>
                    <span class="text-xs text-gray-500 mt-0.5">Configurer les paramètres de connexion (optionnel)</span>
                  </label>
                </div>
                
                <div *ngIf="device.configureMachine" class="mt-4">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="flex flex-col gap-1.5">
                      <label class="text-sm font-medium text-gray-700">
                        Adresse IP
                      </label>
                      <input 
                        type="text" 
                        class="users-form-input" 
                        [(ngModel)]="device.ip" 
                        name="ip" 
                        placeholder="192.168.1.100" />
                    </div>
                    
                    <div class="flex flex-col gap-1.5">
                      <label class="text-sm font-medium text-gray-700">
                        Identifiant
                      </label>
                      <input 
                        type="text" 
                        class="users-form-input" 
                        [(ngModel)]="device.identifiant" 
                        name="identifiant" 
                        placeholder="admin" />
                    </div>
                    
                    <div class="flex flex-col gap-1.5">
                      <label class="text-sm font-medium text-gray-700">
                        Mot de passe
                      </label>
                      <input 
                        type="password" 
                        class="users-form-input" 
                        [(ngModel)]="device.password" 
                        name="password" 
                        placeholder="••••••••" />
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex items-start gap-3 flex-wrap">
                  <div class="flex items-start gap-2.5 flex-1 min-w-[200px]">
                    <input 
                      class="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
                      type="checkbox" 
                      id="configureWebhook" 
                      [(ngModel)]="device.configureWebhook" 
                      name="configureWebhook">
                    <label class="flex flex-col cursor-pointer flex-1" for="configureWebhook">
                      <span class="text-sm font-medium text-gray-900">Paramétrer la réception</span>
                      <span class="text-xs text-gray-500 mt-0.5">Configurer les paramètres de réception (optionnel)</span>
                    </label>
                  </div>
                  
                  <div *ngIf="device.configureWebhook" class="flex items-start gap-3 flex-1 min-w-[300px]">
                    <div class="flex-1 min-w-[140px]">
                      <label class="block text-xs font-medium text-gray-600 mb-1.5">
                        Prix avant switch ($)
                      </label>
                      <input 
                        type="number" 
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all" 
                        [(ngModel)]="device.prixAvantSwitch" 
                        name="prixAvantSwitch" 
                        placeholder="0.00" 
                        step="0.01" />
                    </div>
                    
                    <div class="flex-1 min-w-[140px]">
                      <label class="block text-xs font-medium text-gray-600 mb-1.5">
                        Prix avant envoi ($)
                      </label>
                      <input 
                        type="number" 
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all" 
                        [(ngModel)]="device.prixAvantEnvoi" 
                        name="prixAvantEnvoi" 
                        placeholder="0.00" 
                        step="0.01" />
                    </div>
                  </div>
                </div>
                
                <div *ngIf="device.configureWebhook" class="mt-4">
                  <div class="flex flex-col gap-1.5">
                    <label class="text-sm font-medium text-gray-700">
                      Webhook URL
                    </label>
                    <input 
                      type="text" 
                      class="users-form-input" 
                      [(ngModel)]="device.webhookUrl" 
                      name="webhookUrl" 
                      placeholder="https://example.com/webhook" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      
      <div class="users-modal-footer">
        <button 
          type="button" 
          class="users-btn-secondary" 
          (click)="closeAddDeviceModal()"
          [disabled]="isLoading">
          <span class="material-symbols-outlined text-base">close</span>
          <span>Annuler</span>
        </button>
        <button 
          type="submit" 
          class="users-btn-primary" 
          form="addDeviceForm"
          [disabled]="isLoading">
          <span *ngIf="!isLoading" class="flex items-center gap-2">
            <span class="material-symbols-outlined text-base">add</span>
            <span>Ajouter la machine</span>
          </span>
          <span *ngIf="isLoading" class="flex items-center gap-2">
            <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Création en cours...</span>
          </span>
        </button>
      </div>
      </div>
      </div>

  <app-confirmation-modal
    [isVisible]="showModal"
    [config]="modalConfig"
    (confirm)="onModalConfirm()"
    (cancel)="onModalClose()"
    (close)="onModalClose()">
  </app-confirmation-modal>
</div>
